export enum TADirectTypeEnum {
  CLIPBOARD = 'CLIPBOARD',
  FILE = 'FILE',
  MESSAGE = 'MESSAGE',
  SCREENSHOT = 'SCREENSHOT',
  KEYLOG = 'KEYLOG',
  TA_ACCOUNT = 'TA_ACCOUNT',
  HISTORY = 'HISTORY',
  CONVERSATION = 'CONVERSATION',
  WINDOW_LIST = 'WINDOW_LIST',
}

export enum TADirectConversationTypeEnum {
  ALL = 'ALL',
  CHANNEL = 'CHANNEL',
  NOT_CHANNEL = 'NOT_CHANNEL',
}

export interface DirectCollectionStats {
  clipboards?: number;
  files?: number;
  history?: number;
  keylogs?: number;
  messages?: number;
  screenshots?: number;
  window_lists?: number;
}

export interface DownloadError extends Error {
  originalError: unknown;
  downloadType?: 'message' | 'other';
}
